//@ts-check

import { parseHtml } from 'helpers';
// @ts-ignore
import stylesCourse from 'styles/Course.module.scss';
import React from 'react';

const MultipleChoiceMarking = ({ result }) => {
  const listYourAnswer = result?.result;

  return (
    <>
      {result?.resultAnswers
        ?.filter((item, index) => listYourAnswer?.[index])
        .map((item, index) => (
          <div key={index}>
            <div
              className={
                `flexRow ${stylesCourse['item-section-normal']}` +
                ` ${stylesCourse['item-section-enabled']}`
              }
              style={{
                // @ts-ignore
                '--labelcolor': '#c1c9d4',
              }}
            >
              <span
                className={`w-100 px-md-2 px-05 py-05 ${stylesCourse['item-unit-label']}`}
              >
                <span
                  className={`w-100 mtc-order-width fill-overflow-image ${stylesCourse['item-unit-title']}`}
                >
                  <strong> {parseHtml(item.content)}</strong>
                </span>
              </span>
            </div>
          </div>
        ))}
    </>
  );
};

export default MultipleChoiceMarking;
